var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReserveTableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_67024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9753 20.7487H8V14.9866C8 13.2795 9.38385 11.8956 11.091 11.8956H42.8843C44.5914 11.8956 45.9753 13.2795 45.9753 14.9866V20.7487Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9753 20.7487H8V45.0135C8 46.7206 9.38385 48.1045 11.091 48.1045H42.8843C44.5914 48.1045 45.9753 46.7206 45.9753 45.0135V20.7487Z",
    fill: "#FFF2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9876 43.0852C31.8813 43.0852 35.8484 39.1181 35.8484 34.2244C35.8484 29.3307 31.8813 25.3635 26.9876 25.3635C22.0938 25.3635 18.1267 29.3307 18.1267 34.2244C18.1267 39.1181 22.0938 43.0852 26.9876 43.0852Z",
    fill: "#C8EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9876 39.7293C30.0278 39.7293 32.4925 37.2647 32.4925 34.2244C32.4925 31.1841 30.0278 28.7195 26.9876 28.7195C23.9473 28.7195 21.4827 31.1841 21.4827 34.2244C21.4827 37.2647 23.9473 39.7293 26.9876 39.7293Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1003 29.9409C10.7345 29.9409 10.438 29.6443 10.438 29.2786V25.6135C10.438 25.2477 10.7346 24.9512 11.1003 24.9512C11.4661 24.9512 11.7626 25.2477 11.7626 25.6135V29.2786C11.7627 29.6444 11.4661 29.9409 11.1003 29.9409Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6037 29.9409C13.2379 29.9409 12.9414 29.6443 12.9414 29.2786V25.6135C12.9414 25.2477 13.238 24.9512 13.6037 24.9512C13.9695 24.9512 14.266 25.2477 14.266 25.6135V29.2786C14.266 29.6444 13.9696 29.9409 13.6037 29.9409Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1071 29.9409C15.7413 29.9409 15.4448 29.6443 15.4448 29.2786V25.6135C15.4448 25.2477 15.7414 24.9512 16.1071 24.9512C16.4729 24.9512 16.7695 25.2477 16.7695 25.6135V29.2786C16.7696 29.6444 16.473 29.9409 16.1071 29.9409Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1003 29.2785V31.4864C11.1003 32.0718 11.5748 32.5462 12.1601 32.5462H12.4557V41.9371C12.4557 42.5712 12.9697 43.0852 13.6038 43.0852C14.2378 43.0852 14.7519 42.5713 14.7519 41.9371V32.5461H15.0475C15.6328 32.5461 16.1072 32.0717 16.1072 31.4863V29.2784L11.1003 29.2785Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7097 32.5462H11.4978C10.9124 32.5462 10.438 32.0717 10.438 31.4864V29.2786H16.7695V31.4864C16.7695 32.0717 16.2951 32.5462 15.7097 32.5462Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8748 29.0798C42.8748 27.1653 41.6194 25.6134 40.0708 25.6134C38.5222 25.6134 37.2668 27.1653 37.2668 29.0798C37.2668 30.0297 37.5761 30.89 38.0769 31.5159C38.3186 31.818 38.6051 32.0655 38.9228 32.2421V41.9371C38.9228 42.5711 39.4368 43.0852 40.0709 43.0852C40.7049 43.0852 41.219 42.5712 41.219 41.9371V32.2421C42.1948 31.6998 42.8748 30.4884 42.8748 29.0798Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5018 17.4593C36.4775 17.4593 35.6472 16.629 35.6472 15.6047V9.90845C35.6472 8.88416 36.4775 8.05383 37.5018 8.05383C38.5261 8.05383 39.3565 8.88416 39.3565 9.90845V15.6047C39.3565 16.629 38.5261 17.4593 37.5018 17.4593Z",
    fill: "#F9C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4733 17.4593C15.449 17.4593 14.6187 16.629 14.6187 15.6047V9.90845C14.6187 8.88416 15.449 8.05383 16.4733 8.05383C17.4976 8.05383 18.3279 8.88416 18.3279 9.90845V15.6047C18.3279 16.629 17.4976 17.4593 16.4733 17.4593Z",
    fill: "#F9C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.884 11.8956H39.8799C41.587 11.8956 42.9709 13.2795 42.9709 14.9866V20.7488H45.975V14.9866C45.975 13.2795 44.5911 11.8956 42.884 11.8956Z",
    fill: "#D83131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9709 20.7487V45.0135C42.9709 46.7206 41.587 48.1045 39.8799 48.1045H42.884C44.5911 48.1045 45.975 46.7206 45.975 45.0135V20.7487H42.9709Z",
    fill: "#FEE8C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7661 51.9462C47.8659 51.9462 52 47.812 52 42.7123C52 37.6126 47.8659 33.4784 42.7661 33.4784C37.6664 33.4784 33.5322 37.6126 33.5322 42.7123C33.5322 47.812 37.6664 51.9462 42.7661 51.9462Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7662 33.4784C42.2547 33.4784 41.7531 33.5207 41.2642 33.6007C45.6494 34.3182 48.996 38.1241 48.996 42.7123C48.996 47.3005 45.6495 51.1064 41.2642 51.8239C41.7531 51.9039 42.2547 51.9462 42.7662 51.9462C47.8659 51.9462 52.0001 47.812 52.0001 42.7123C52.0001 37.6126 47.8659 33.4784 42.7662 33.4784Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3658 48.1846C40.3591 48.1846 40.3524 48.1846 40.3455 48.1845C40.0056 48.1786 39.6852 48.0246 39.4682 47.7629L36.2411 43.8695C35.8303 43.3739 35.8991 42.6389 36.3948 42.2281C36.8904 41.8172 37.6252 41.8859 38.0363 42.3816L40.3969 45.2297L46.0599 38.8612C46.4876 38.3802 47.2244 38.3368 47.7057 38.7647C48.1868 39.1925 48.23 39.9294 47.8021 40.4105L41.2369 47.7935C41.0155 48.0425 40.6983 48.1846 40.3658 48.1846Z",
    fill: "#F9C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_67024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveTableIcon);
export default __webpack_public_path__ + "static/media/reserve-table-icon.5a382de70a40b01ee8c3b3a063eeeae5.svg";
export { ForwardRef as ReactComponent };